import moment from 'moment';

import { getIsSchedulerDragActive } from 'bl/scheduler/schedulerDragLock.bl';
import FLAG from 'config/flag.singleton';
import logger from 'utils/logger.util';
import equalShallow from 'utils/objects/equalShallow.util';

const L = logger('shouldUpdateDayColumn'); // eslint-disable-line no-unused-vars

const UPDATE_KEYS = Object.freeze(['addedServices', 'booking', 'bookingTime', 'currentActiveProcedure', 'rangeByHours']);

const shouldUpdateDayColumn = (options) => {
  if (FLAG.updateColumnsAlways) return true;
  if (getIsSchedulerDragActive()) return false;

  const prev = options?.prev ?? {};
  const next = options?.next ?? {};

  if (prev.isDragDisabledByFetch !== next.isDragDisabledByFetch) return true;
  if (prev.isProcedureModalMounted !== next.isProcedureModalMounted) return true;
  if (prev.panel !== next.panel) return true;

  const keys = Object.keys(next);

  for (const key of keys) {
    const isUpdateKey = UPDATE_KEYS.includes(key);
    const isHoverKey = 'hoveredCell' === key;
    const areDifferent = !equalShallow(next[key], prev[key]);

    if (!isUpdateKey && !isHoverKey && areDifferent) return true;

    const prevId = prev?.stylist?.id;
    const nextId = next?.stylist?.id;

    const firstOg = prev?.rangeByHours?.[0];
    const firstNg = next?.rangeByHours?.[0];
    const lastOg = prev?.rangeByHours?.[prev?.rangeByHours?.length - 1];
    const lastNg = next?.rangeByHours?.[next?.rangeByHours?.length - 1];

    if (!isUpdateKey && areDifferent && isHoverKey && ((next.hoveredCell && next.hoveredCell.stylistId === prevId) || (prev.hoveredCell && prev.hoveredCell.stylistId === prevId))) {
      return true;
    }

    if (!isUpdateKey) continue;

    if (key === 'addedServices') {
      for (let i = 0; i < next.addedServices.length; i += 1) {
        const addedServiceOg = prev?.addedServices?.[i];
        const addedServiceNg = next.addedServices[i];

        const startOg = addedServiceOg?.start_time;
        if (addedServiceOg && moment(startOg).isSame(startOg)) return true;

        const startNg = moment(addedServiceNg.start_time);
        if (startNg.isSameOrAfter(firstOg) && startNg.isSameOrBefore(lastOg) && areDifferent) return true;
      }

      for (let j = 0; j < prev.addedServices.length; j += 1) {
        const startOg = moment(prev.addedServices[j].start_time);
        if (startOg.isSameOrAfter(firstOg) && startOg.isSameOrBefore(lastOg) && areDifferent) return true;
      }
    } else if (key === 'booking') {
      if ((next.booking.currentStylistId === nextId || prev.booking.currentStylistId === prevId) && areDifferent) {
        return true;
      }
    } else if (key === 'bookingTime') {
      const nextBookingTimeAsMoment = moment(next.bookingTime);
      if (next.bookingTime && nextBookingTimeAsMoment.isSameOrAfter(firstOg) && nextBookingTimeAsMoment.isSameOrBefore(lastOg)) {
        if (areDifferent) return true;
      } else {
        const prevBookingTimeAsMoment = moment(prev.bookingTime);
        if (prev.bookingTime && prevBookingTimeAsMoment.isSameOrAfter(firstOg) && prevBookingTimeAsMoment.isSameOrBefore(lastOg) && areDifferent) {
          return true;
        }
      }
    } else if (key === 'currentActiveProcedure') {
      const nextCurrentActiveMatch = next.allProcedures.find((p) => p.id === next.currentActiveProcedure);
      const thisCurrentActiveMatch = prev.allProcedures.find((p) => p.id === prev.currentActiveProcedure);
      if (nextCurrentActiveMatch || thisCurrentActiveMatch) {
        return next.currentActiveProcedure !== prev.currentActiveProcedure;
      }
    } else if (key === 'rangeByHours') {
      // Only redraw if the start or end time has changed
      if (firstOg.format('h:mm') !== firstNg.format('h:mm') || lastOg.format('h:mm') !== lastNg.format('h:mm')) {
        return true;
      }
    }
  }

  if (FLAG.updateColumnsLogNegatives) L.debug('()', false, '<-', options);

  return false;
};

export default shouldUpdateDayColumn;
